// To fire map events in the RanaMap component as a side effect to the Map

import { Extent } from "@nens/shared-utils";

import { useMapBounds } from "../hooks/use-map-bounds";
import { useMapTransformRequest } from "../hooks/use-map-transform-request";

export type RanaMapEventsProps = {
  dontApplyInitialBounds?: boolean;
  bounds?: Extent | null;
};

export function RanaMapEvents({ dontApplyInitialBounds, bounds }: RanaMapEventsProps) {
  // Fit map to bounds whenever map bounds change
  useMapBounds(bounds, dontApplyInitialBounds);

  // Update the transformRequest function with new token
  useMapTransformRequest();

  return null;
}
